import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Card,
  CardBody,
  CardImg,
  CardTitle,
  Row,
  CardText,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import api from "../../../../../../../services/api";
import { ModeloSite, UsuarioModeloSite } from "../../CentralVendedor";
import "./styles.css";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { EmpresaModeloSite } from "../../../../../../common/Empresas/MinhaEmpresa/Sites";
import classnames from "classnames";
import { EditarModeloModal } from "./EditarModeloModal";
import useModal from "./useModal";

interface SelecionarModeloModalProps {
  onClose: () => void;
  isOpen: boolean;
  reload: () => Promise<void>;
  paginaAfiliacao: UsuarioModeloSite | EmpresaModeloSite | undefined;
}

export function SelecionarModeloModal({
  isOpen,
  onClose,
  reload,
  paginaAfiliacao,
}: SelecionarModeloModalProps) {
  const [selectedModeloSite, setSelectedModeloSite] = useState<
    ModeloSite | undefined
  >(paginaAfiliacao?.site);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [alert, setAlert] = useState<React.ReactNode | null>(null);
  const [preview, setPreview] = useState("");
  const [activeTab, setActiveTab] = useState("1");
  const [modelosCatalogo, setModelosCatalogo] = useState<ModeloSite[]>([]);
  const [modelosStandard, setModelosStandard] = useState<ModeloSite[]>([]);
  const [modelosAutonomo, setModelosAutonomo] = useState<ModeloSite[]>([]);

  const [isEditModalVendedorVisible, setIsEditModalVendedorVisible] =
    useModal();

  const toggle = (tab: any) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  useEffect(() => {
    setSelectedModeloSite(paginaAfiliacao?.site);
  }, [paginaAfiliacao?.site]);

  useEffect(() => {
    switch (activeTab) {
      case "1": {
        if (modelosStandard.length === 0) {
          loadModelosStandard();
        }
        break;
      }
      case "2": {
        if (modelosCatalogo.length === 0) {
          loadModelosCatalogo();
        }
        break;
      }
      case "3": {
        if (modelosAutonomo.length === 0) {
          loadModelosAutonomo();
        }
        break;
      }
    }
  }, [activeTab]);

  async function loadModelosStandard() {
    try {
      const { data } = await api.get(`/marketing/ms?layout=${1}`);

      setModelosStandard(data);
    } catch (error) {
      console.error("Houve um erro ao carregar os dados do site.", error);
    }
  }

  async function loadModelosCatalogo() {
    try {
      const { data } = await api.get(`/marketing/ms?layout=${2}`);

      setModelosCatalogo(data);
    } catch (error) {
      console.error("Houve um erro ao carregar os dados do site.", error);
    }
  }

  async function loadModelosAutonomo() {
    try {
      const { data } = await api.get(`/marketing/ms?layout=${4}`);

      setModelosAutonomo(data);
    } catch (error) {
      console.error("Houve um erro ao carregar os dados do site.", error);
    }
  }

  function handleCloseModal() {
    setSelectedModeloSite(paginaAfiliacao?.site);
    onClose();
  }

  return (
    <>
      <EditarModeloModal
        isOpen={isEditModalVendedorVisible}
        onCloseParams={setIsEditModalVendedorVisible}
        onCloseModelo={handleCloseModal}
        _shortUrl={paginaAfiliacao?.short_url}
        usuarioSite={selectedModeloSite}
        usuarioUMSId={paginaAfiliacao?.id}
        reload={reload}
      />
      {alert}
      <Modal
        isOpen={isOpen}
        toggle={handleCloseModal}
        style={{ maxWidth: "90%" }}
      >
        <ModalHeader toggle={handleCloseModal}>Selecione o modelo</ModalHeader>
        <ModalBody
          style={{ height: "70vh", overflowY: "scroll", paddingTop: 0 }}
        >
          <Nav tabs className="sticky-top bg-white">
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "1" })}
                onClick={() => {
                  toggle("1");
                }}
              >
                Standard
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "2" })}
                onClick={() => {
                  toggle("2");
                }}
              >
                Catálogo
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "3" })}
                onClick={() => {
                  toggle("3");
                }}
              >
                Autônomo
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <div
                style={{
                  display: "grid",
                  gap: "1rem",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  paddingBlock: "1rem",
                }}
              >
                {modelosStandard.map((page, index) => {
                  const isCurrentSite =
                    selectedModeloSite?.id != undefined &&
                    selectedModeloSite?.id == page.id;
                  return (
                    <Card key={page.id}>
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setPreview(page.link);
                          setIsFullScreen(true);
                        }}
                        className="magnifier"
                      >
                        <CardImg
                          top
                          width="100%"
                          style={{ maxWidth: "100%" }}
                          src={
                            page.link + "preview.png" ||
                            "https://internal.playnee.com/vendedor/capa.png"
                          }
                          alt="Card image cap"
                        />
                      </div>

                      <CardBody>
                        <CardTitle tag="h5">Modelo {index + 1}</CardTitle>
                        <Button
                          size="sm"
                          color="primary"
                          disabled={isCurrentSite}
                          onClick={() => setSelectedModeloSite(page)}
                        >
                          {isCurrentSite ? "Modelo Atual" : "Selecionar Modelo"}
                        </Button>
                      </CardBody>
                    </Card>
                  );
                })}
              </div>
            </TabPane>
            <TabPane tabId="2">
              {modelosCatalogo.length === 0 && (
                <span>Nenhum modelo encontrado.</span>
              )}
              <div
                style={{
                  display: "grid",
                  gap: "1rem",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  paddingBlock: "1rem",
                }}
              >
                {modelosCatalogo.map((page, index) => {
                  const isCurrentSite =
                    selectedModeloSite?.id != undefined &&
                    selectedModeloSite?.id == page.id;
                  return (
                    <Card key={page.id}>
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setPreview(page.link);
                          setIsFullScreen(true);
                        }}
                        className="magnifier"
                      >
                        <CardImg
                          top
                          width="100%"
                          style={{ maxWidth: "100%" }}
                          src={
                            page.link + "preview.png" ||
                            "https://internal.playnee.com/vendedor/capa.png"
                          }
                          alt="Card image cap"
                        />
                      </div>

                      <CardBody>
                        <CardTitle tag="h5">Modelo {index + 1}</CardTitle>
                        <Button
                          size="sm"
                          color="primary"
                          disabled={isCurrentSite}
                          onClick={() => setSelectedModeloSite(page)}
                        >
                          {isCurrentSite ? "Modelo Atual" : "Selecionar Modelo"}
                        </Button>
                      </CardBody>
                    </Card>
                  );
                })}
              </div>
            </TabPane>
            <TabPane tabId="3">
              {modelosAutonomo.length === 0 && (
                <span>Nenhum modelo encontrado.</span>
              )}
              <div
                style={{
                  display: "grid",
                  gap: "1rem",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  paddingBlock: "1rem",
                }}
              >
                {modelosAutonomo.map((page, index) => {
                  const isCurrentSite =
                    selectedModeloSite?.id != undefined &&
                    selectedModeloSite?.id == page.id;
                  return (
                    <Card key={page.id}>
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setPreview(page.link);
                          setIsFullScreen(true);
                        }}
                        className="magnifier"
                      >
                        <CardImg
                          top
                          width="100%"
                          style={{ maxWidth: "100%" }}
                          src={
                            page.link + "preview.png" ||
                            "https://internal.playnee.com/vendedor/capa.png"
                          }
                          alt="Card image cap"
                        />
                      </div>

                      <CardBody>
                        <CardTitle tag="h5">Modelo {index + 1}</CardTitle>
                        <Button
                          size="sm"
                          color="primary"
                          disabled={isCurrentSite}
                          onClick={() => setSelectedModeloSite(page)}
                        >
                          {isCurrentSite ? "Modelo Atual" : "Selecionar Modelo"}
                        </Button>
                      </CardBody>
                    </Card>
                  );
                })}
              </div>
            </TabPane>
          </TabContent>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleCloseModal}>
            Voltar
          </Button>
          {/* <Button
						color="primary"
						onClick={handleSave}
						disabled={!selectedModeloSiteId || selectedModeloSiteId == currentSiteId}
					>
						Salvar
					</Button> */}
          <Button
            color="primary"
            onClick={setIsEditModalVendedorVisible}
            disabled={!selectedModeloSite}
          >
            Próximo
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={isFullScreen}
        style={{ maxWidth: "min-content" }}
        toggle={() => setIsFullScreen(false)}
      >
        <img
          src={
            preview + "preview.png" ||
            "https://internal.playnee.com/vendedor/capa.png"
          }
          alt="Card image cap"
          style={{ maxWidth: "1440px", display: "block", borderRadius: "8px" }}
        />
      </Modal>
    </>
  );
}
